import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import AgeRangeReaches from 'common/domain/AgeRangeReaches';
import { Percent } from '../../components/Number';

const Content = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  margin: ${({ theme }) => `${theme.metrics.margin}px ${theme.metrics.smallMargin}px`};
  justify-content: ${({ justifyContent }) => justifyContent};
`;

const AverageNumber = styled.span`
  font-size: 1.4rem;
  white-space: nowrap;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${({ direction }) => direction};
  margin: ${({ theme }) => `0 ${theme.metrics.margin}px`};
`;

const LabelTitle = styled.span`
  font-size: 1.2rem;
  margin-right: ${({ theme }) => `${theme.metrics.margin}px`};
  color: ${({ theme }) => theme.colors.primaryText};
`;

type Props = {
  ageGroup: AgeRangeReaches;
  labelStyle?: Object;

  direction?: 'vertical' | 'horizontal',
  t: any
}

function CommercialAgeGroup({ direction, labelStyle, ageGroup, t }: Props) {
  const flexDirection = direction === 'horizontal' ? 'row' : 'column';
  const justifyContent = direction === 'horizontal' ? 'center' : 'flex-start';

  return (
    <Content direction={flexDirection} justifyContent={justifyContent}>
      <Wrapper direction={flexDirection}>
        <LabelTitle style={labelStyle}>{t('a25to54')}</LabelTitle>
        <AverageNumber>
          <Percent value={ageGroup.getPercentFor(['25-34', '35-44', '45-54'])} />
        </AverageNumber>
      </Wrapper>
      <Wrapper direction={flexDirection}>
        <LabelTitle style={labelStyle}>{t('a35plus')}</LabelTitle>
        <AverageNumber>
          <Percent value={ageGroup.getPercentFor(['35-44', '45-54', '55-64', '65+'])} />
        </AverageNumber>
      </Wrapper>
    </Content>
  );
}

export default translate('common')(CommercialAgeGroup);



// WEBPACK FOOTER //
// ./src/common/components/charts/CommercialAgeGroup.js